import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const data = [
  { name: "Group A", value: 400 }
];

const FinanceDonutChart = ({color}) => {
  return (
    <PieChart width={200} height={200}>
      <Pie
        data={data}
        cx={90}
        cy={100}
        innerRadius={60}
        outerRadius={80}
        fill="#9AABDD"
        paddingAngle={0}
        dataKey="value" 
         >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={color} />
        ))}
      </Pie>
    </PieChart>
  )
}

export default FinanceDonutChart